var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63965 13C9.01592 13 9.33671 12.865 9.60203 12.5951C9.86734 12.3252 10 11.9989 10 11.6161V5.49151C10 5.10872 9.86734 4.77992 9.60203 4.5051C9.33671 4.23028 9.01592 4.09286 8.63965 4.09286H7.91606V3.0034C7.91606 2.16912 7.63386 1.45998 7.06946 0.875991C6.50507 0.291997 5.81766 0 5.00724 0C4.19682 0 3.50941 0.291997 2.94501 0.875991C2.38061 1.45998 2.09841 2.16912 2.09841 3.0034V4.09286H1.37482C0.998553 4.09286 0.675349 4.23028 0.40521 4.5051C0.13507 4.77992 0 5.10872 0 5.49151V11.6161C0 11.9989 0.13507 12.3252 0.40521 12.5951C0.675349 12.865 0.998553 13 1.37482 13H8.63965ZM6.55572 4.09286H3.45876V3.0034C3.45876 2.54209 3.60589 2.15931 3.90014 1.85504C4.1944 1.55077 4.56343 1.39864 5.00724 1.39864C5.44139 1.39864 5.80801 1.55077 6.10709 1.85504C6.40617 2.15931 6.55572 2.54209 6.55572 3.0034V4.09286Z",
    fill: "#014189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSmall);
export default __webpack_public_path__ + "static/media/Lock_small.e82a0a3a96aa44650f0e7c35d20d2ed6.svg";
export { ForwardRef as ReactComponent };